import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import React, { useEffect, useState } from "react"
import { View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"

const InformationBarComponent = (props) => {
    const {
        bgColor = theme.colors.warning,
        isWaitingForTutor = false,
        waitingMessage = "Ton tuteur ne devrait pas tarder. En attendant, travaille sur ton activité !"
    } = props

    const [localShowBarIfNeeded, setLocalShowBarIfNeeded] = useState(false)
    const { showBar, setShowBar } = props?.setShowBar
        ? props
        : { showBar: localShowBarIfNeeded, setShowBar: setLocalShowBarIfNeeded }
    // Priority system for messages
    // 1. Waiting for tutor (highest priority)
    // 2. Silent mode
    const description = isWaitingForTutor
        ? waitingMessage
        : props.isSilentMode
        ? props.isHandRaised ? "En mode concentré, l'audio est coupé. Avance sur un exercice, en attendant ton masteur."
            : "En mode concentré, l'audio est coupé. Lève la main ou écris un message à ton masteur."
        : null

    const icon = isWaitingForTutor
        ? "clock"
        : props.isSilentMode
        ? "volume-mute"
        : null

    const showBar_calculated =
        isWaitingForTutor ||
        props.isSilentMode

    useEffect(() => {
        setTimeout(() => {
            setShowBar(true)
        }, 200)
    }, [])

    if (!showBar_calculated) return

    return (
        showBar && (
            <View
                style={{
                    width: "100%",
                    height: 50,
                    backgroundColor: bgColor,
                    paddingHorizontal: 15,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <FontAwesome5
                    name={icon}
                    size={16}
                    color={theme.colors.white}
                    style={{ marginRight: 10, marginLeft: 10 }}
                />
                <TextM
                    wrap
                    color={theme.colors.white}
                    fontWeight={"SemiBold"}
                    style={{ marginRight: 10 }}
                    fontSize={11}
                >
                    {description}
                </TextM>
            </View>
        )
    )
}
export default InformationBarComponent
